import { useEffect } from 'react';
import { db, doc, onSnapshot } from '@/firebase';

export default function DynamicFavicon() {
  useEffect(() => {
    try {
      const unsub = onSnapshot(doc(db, 'settings', 'website'), (snapshot) => {
        if (snapshot.exists() && snapshot.data()?.logoUrl) {
          const logoUrl = snapshot.data().logoUrl.trim();
          if (logoUrl) {
            updateFaviconLinks(logoUrl);
          }
        }
      }, (err) => {
        console.warn('Favicon real-time sync notice:', err);
      });

      return () => unsub();
    } catch (e) {
      console.warn('Failed to listen to website logo for favicon:', e);
    }
  }, []);

  return null;
}

export function updateFaviconLinks(url: string) {
  if (!url || typeof document === 'undefined') return;

  const rels = ['icon', 'shortcut icon', 'apple-touch-icon'];

  rels.forEach((rel) => {
    let link = document.querySelector(`link[rel='${rel}']`) as HTMLLinkElement | null;
    if (!link) {
      link = document.createElement('link');
      link.rel = rel;
      document.head.appendChild(link);
    }
    link.href = url;
  });
}
